import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const ManageSubscriptionContainer = styled.div`
	.statusForm {
		display: flex;
		justify-content: center;

		@media ${Breakpoints.mobile && Breakpoints.tablet} {
			display: grid;
			border-right: none;
			gap: 1rem;
			> div:last-of-type {
				border-right: none;
				border-bottom: none;
			}
		}

		> div {
			padding: 0 4rem;
			border-right: 1px solid var(--border-color);
			body[dir='rtl'] & {
				border-left: 1px solid var(--border-color);
				border-right: unset;
			}
			@media ${Breakpoints.mobile && Breakpoints.tablet} {
				border-right: none;
				border-bottom: 1px solid var(--border-color);
			}
		}
		> div:last-of-type {
			border-right: none;
			body[dir='rtl'] & {
				border-left: none;
			}
		}
	}
`;

export const ItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	margin: auto;
	gap: 1rem;
`;

export const ItemBox = styled.div`
	display: block;
	width: 60rem;
	border: 1px solid var(--border-color);
	border-radius: 0.5rem;
	padding: 1rem;
	margin: auto;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	@media ${Breakpoints.mobile} {
		width: 45rem;
	}
`;

export const ItemBoxNoBorder = styled.div`
	display: block;
	width: 60rem;
	border-radius: 0.5rem;
	margin: auto;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	@media ${Breakpoints.mobile} {
		width: 45rem;
	}
`;

export const InlineTypography = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
`;

export const Box = styled.div`
	width: 60rem;
	margin: auto;
`;

export const BoxTitle = styled.div`
	display: flex;
	gap: 1rem;
	align-items: center;
`;

export const FlexContainer = styled.div`
	display: flex;
`;
